import { defineStore } from 'pinia';
import { IContactFormStore, IFormItem, ICountryItem } from '../utils/interfaces';

const getFirstItemProperty = (formItems: Array<IFormItem>, propertyToGet: keyof IFormItem) => {
  const firstItem = formItems.length > 0 ? formItems[0] : null;
  return firstItem ? firstItem[propertyToGet] : null 
}

export const useContactFormStore = defineStore('contactFormStore', {
  state: (): IContactFormStore => ({
    apiError: false,
    pathError: false,
    dataError: false,
    dataReady: false,
    formItems: [] as IFormItem[],
    countryItems: [] as ICountryItem[],
    formSent: false,
    formSentError: false,
    recaptchaUrl: '',
    recaptchaActionWord: '',
    recaptchaSiteKey: ''
  }),
  getters: {
    hasError: (state): boolean => state.apiError || state.pathError || state.dataError,
    getFormItems: (state): Array<IFormItem> => state.formItems,
    getCountryItems: (state): Array<ICountryItem> => state.countryItems,
    getFirstFormItem: (state): IFormItem | null => state.formItems.length > 0 ? state.formItems[0] : null,
    getFormProcessorApiEndPoint: (state): string | null => getFirstItemProperty(state.formItems, 'formProcessorApiEndpoint') as string | null,
    getContactListApiEndPoint: (state): string | null => getFirstItemProperty(state.formItems, 'contactListApiEndpoint') as string | null,
    getFormConfigurationPath: (state): string | null => getFirstItemProperty(state.formItems, 'formConfigurationPath') as string | null,
    getFormTemplatePath: (state): string | null => getFirstItemProperty(state.formItems, 'formTemplatePath') as string | null,
    getMarket: (state): string | null => getFirstItemProperty(state.formItems, 'market') as string | null,
    getRecaptchaUrl: (state): string => ''.concat(state.recaptchaUrl, state.recaptchaSiteKey),
    getRecaptchaActionWord: (state): string => state.recaptchaActionWord,
    getRecaptchaSiteKey: (state): string => state.recaptchaSiteKey,
    showForm: (state): boolean => state.dataReady && !state.formSent,
    showResult: (state): boolean => state.dataReady && state.formSent,
    showSuccessMessage: (state): boolean => state.dataReady && state.formSent && !state.formSentError,
    showFailureMessage: (state): boolean => state.dataReady && state.formSent && state.formSentError
  },
  actions: {
    setRecaptchaParams(formItem: IFormItem) {
      this.recaptchaUrl = formItem.recaptchaGoogleUrl;
      this.recaptchaActionWord = formItem.recaptchaActionWord;
      this.recaptchaSiteKey = formItem.recaptchaSiteKey;
    },
    loadFormAndCountryItems(formItems: Array<IFormItem>, countryItems: Array<ICountryItem>) {
      this.formItems = formItems;
      const firstItem = this.getFirstFormItem;
      if (firstItem) this.setRecaptchaParams(firstItem);
      this.countryItems = countryItems;
      this.dataReady = true;
    },
    updateFormStatus(hasError: boolean) {
      this.formSent = true;
      this.formSentError = hasError;
    }
  }
});
